module.exports = __webpack_public_path__ + "static/img/banner3.8fbfd573.jpg";